import { render, staticRenderFns } from "./PayPackage.vue?vue&type=template&id=f0100068&scoped=true&"
import script from "./PayPackage.vue?vue&type=script&lang=js&"
export * from "./PayPackage.vue?vue&type=script&lang=js&"
import style0 from "./PayPackage.vue?vue&type=style&index=0&id=f0100068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0100068",
  null
  
)

export default component.exports